'use client';

import React, { ReactNode } from 'react';

/**
 * 共通アイコン（Good）
 * @param param0
 * @returns
 */
export const GoodAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic bg-green-400 text-white text-xs font-semibold px-2.5 py-1 rounded-full dark:bg-green-900 dark:text-green-300">
      Good
      <svg
        className="inline w-2.5 h-2.5 ms-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 18 18">
        <path d="M3 7H1a1 1 0 0 0-1 1v8a2 2 0 0 0 4 0V8a1 1 0 0 0-1-1Zm12.954 0H12l1.558-4.5a1.778 1.778 0 0 0-3.331-1.06A24.859 24.859 0 0 1 6 6.8v9.586h.114C8.223 16.969 11.015 18 13.6 18c1.4 0 1.592-.526 1.88-1.317l2.354-7A2 2 0 0 0 15.954 7Z" />
      </svg>
    </div>
  );
};

/**
 * 共通アイコン（Bad）
 * @param param0
 * @returns
 */
export const BadAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic bg-indigo-400 text-white text-xs font-semibold px-2.5 py-1 rounded-full dark:bg-indigo-900 dark:text-indigo-300">
      Bad
      <svg
        className="inline w-2.5 h-2.5 ms-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 18 18">
        <path d="M11.955 2.117h-.114C9.732 1.535 6.941.5 4.356.5c-1.4 0-1.592.526-1.879 1.316l-2.355 7A2 2 0 0 0 2 11.5h3.956L4.4 16a1.779 1.779 0 0 0 3.332 1.061 24.8 24.8 0 0 1 4.226-5.36l-.003-9.584ZM15 11h2a1 1 0 0 0 1-1V2a2 2 0 1 0-4 0v8a1 1 0 0 0 1 1Z" />
      </svg>
    </div>
  );
};

/**
 * 共通アイコン（Next）
 * @param param0
 * @returns
 */
export const NextAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic bg-yellow-400 text-white text-xs font-semibold px-2.5 py-1 rounded-full dark:bg-yellow-900 dark:text-yellow-300">
      Next
      <svg
        className="inline w-3 h-3 ms-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 18 16">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 10l3-4 4 4 5-5m0 0h-3.207M16 5v3.207"
        />
      </svg>
    </div>
  );
};

/**
 * 共通アイコン（グラデーションアイコン）
 * @param param0
 * @returns
 */
interface GradientAiconProps {
  children: ReactNode;
}
export const GradientAicon: React.FC<GradientAiconProps> = ({ children }) => {
  return (
    <div className="w-fit font-footballlog italic bg-gradient-to-r from-purple-700 to-pink-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
      {children}
    </div>
  );
};

/**
 * 共通アイコン（Private）
 * @param param0
 * @returns
 */
export const PrivateAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic border border-gray-400 bg-transparent text-gray-400 text-xs font-semibold px-2 py-0.5 rounded-full">
      Private
    </div>
  );
};

/**
 * 共通アイコン（Score）
 * @param param0
 * @returns
 */
export const ScoreAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic border border-gray-400 bg-transparent text-gray-400 text-xs font-semibold px-2 py-0.5 rounded-full">
      Score
    </div>
  );
};

/**
 * 共通アイコン（Scene）
 * @param param0
 * @returns
 */
export const SceneAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic border border-gray-400 bg-transparent text-gray-400 text-xs font-semibold px-2 py-0.5 rounded-full">
      Scene
    </div>
  );
};

/**
 * 共通アイコン（memo）
 * @param param0
 * @returns
 */
export const MemoAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic border border-gray-400 bg-transparent text-gray-400 text-xs font-semibold px-2 py-0.5 rounded-full">
      Memo
    </div>
  );
};

/**
 * 共通アイコン（AI Feedback）
 * @param param0
 * @returns
 */
export const AIFeedbackAicon: React.FC = () => {
  return (
    <div className="w-fit font-footballlog italic bg-gradient-to-r from-purple-500 to-cyan-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
      AI
    </div>
  );
};

/**
 * 共通アイコン（BETA）
 * @param param0
 * @returns
 */
export const BetaAicon: React.FC = () => {
  return (
    <div className="w-fit flex items-center font-footballlog italic bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400">
      BETA
    </div>
  );
};
